import { StrategyCreate } from './StrategyCreate';
import { StrategyLoad } from './StrategyLoad';

export const CartInitializer = { StrategyLoad, StrategyCreate };
